export default {
  title: {
    add: '新增提现银行卡',
    update: '编辑提现银行卡'
  },
  label: {
    bankAccount: '账号所有人',
    bankBranch: '支行名称',
    bankName: '银行名称',
    bankNo: '银行卡号',
    createBy: '创建人',
    createTime: '创建时间',
    id: '主键id',
    merchatNo: '商户账号',
    updateBy: '修改人',
    updateTime: '修改时间',
    action: '操作'
  },
  rules: {
    bankAccount: '账号所有人不能为空',
    bankBranch: '支行名称不能为空',
    bankName: '银行名称不能为空',
    bankNo: {
      required: '银行卡号不能为空',
      type: '银行卡号必须为数字',
      symboltype: '银行卡号必须为数字字母',
      min: '银行卡号长度必须大于等于5',
      length: '银行卡号长度必须大于4小于31'
    },
    merchatNo: '商户账号不能为空',
    bankCode: '银行编码不能为空',
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/zh/withdrawBank.js